<script setup>
import { Loc } from 'main.core';
const emit = defineEmits(['close']);

const close = () => emit('close');
</script>

<template>
  <div class="cloud-calculator__dialog" @click="close" @keydown.esc="close">
    <div class="cloud-calculator__dialog-wrapper" role="dialog" @click.stop="">
      <div class="cloud-calculator__dialog-header">
        <slot name="title"/>
        <button
          type="button"
          class="popup__close-button"
          :aria-label="Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_BUTTON_CLOSE')"
          @click="close"
        ></button>
      </div>
      <div class="cloud-calculator__dialog-content">
        <slot/>
      </div>
    </div>
  </div>
</template>
